import moment from 'moment-timezone';
import { compose, withHandlers, withPropsOnChange, withState } from 'recompose';

export default compose(
  withState('openedTab', 'setOpenedTab', 'futureItems'),
  withHandlers({
    showFutureItems: props => () => {
      if (props.openedTab !== 'futureItems') {
        props.setOpenedTab('futureItems');
      }
    },
    showPastItems: props => () => {
      if (props.openedTab !== 'pastItems') {
        props.setOpenedTab('pastItems');
      }
    },
  }),
  withState('pastItems', 'setPastItems', []),
  withState('futureItems', 'setFutureItems', []),
  withPropsOnChange(
    ['appointments'],
    ({ appointments, ...props }) => {
      if (appointments && appointments.length) {
        const pastItems = appointments.filter(appt => moment.utc().isAfter(appt.compareDate || appt.start));
        const futureItems = appointments.filter(appt => moment.utc().isBefore(appt.compareDate || appt.start));
        props.setPastItems(pastItems);
        props.setFutureItems(futureItems);
      }
    }
  ),
);
